var map = {
	"./assets/icons.js": [
		314
	],
	"./controls/EmbedButton.js": [
		1434,
		513
	],
	"./controls/helpers.js": [
		1427,
		514
	],
	"./controls/hlsResolutionMenu.js": [
		1429,
		511
	],
	"./controls/mp4ResolutionMenu.js": [
		1430,
		512
	],
	"./controls/news/rewind.js": [
		1431,
		515
	],
	"./controls/news/seasonList.js": [
		1436,
		510
	],
	"./controls/news/skip.js": [
		1432,
		516
	],
	"./controls/news/title.js": [
		1433,
		517
	],
	"./controls/rewind.js": [
		1435,
		518
	],
	"./drmObject.js": [
		309
	],
	"./ima/autoplay.js": [
		1440,
		314
	],
	"./ima/videojs.ima.js": [
		639
	],
	"./index.js": [
		251
	],
	"./neouskin.js": [
		1438,
		509
	],
	"./newsSkin.js": [
		1437,
		149
	],
	"./registerVjsComponent.js": [
		1428,
		519
	],
	"./screens/Embed.js": [
		536
	],
	"./screens/nextVideoTimer.js": [
		308
	],
	"./screens/rating.js": [
		537
	],
	"./screens/videoWall.js": [
		538
	],
	"./skin.js": [
		1439,
		508
	],
	"./video.js": [
		541
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1344;
module.exports = webpackAsyncContext;